<template>
    <div class="table-action-buttons">
        <i class="fa fa-eye fa-lg pointer" @click="modal"></i>
        <i class="fa fa-edit fa-lg pointer" @click="edit" :title="uLang('app.edit_type', { type: lang('app.location') })"></i>
        <i class="fa fa-trash fa-lg pointer" @click="remove" :title="uLang('app.delete_type', { type: lang('app.location') })"></i>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import store from '~/store'
    import { event }  from '~/events'

    export default {
        name: 'actions',
        props: ['data', 'index'],

        computed: mapGetters({
            user: 'authUser'
        }),

        methods: {
            modal() {
                event.init();
                event.emit('showLocation', this.data.id);
            },

            remove() {
                swal({
                    title: this.uLang('app.are_you_sure'),
                    text: this.lang('app.delete_warning_entity', {entity: this.lang('app.location')}),
                    icon: "warning",
                    buttons: [this.uLang('app.cancel'), this.uLang('app.continue')],
                    dangerMode: true,
                })
                    .then((willDelete) => {
                        if (willDelete) {
                            this.destroy()
                        }
                    });
            },

            edit() {
                event.init();
                event.emit('editLocation', this.data.id);
            },

            async destroy() {
                await window.axios.delete('/api/locations/' + this.data.id);
                vue.$emit('reloadTable');
                swal({
                    title: this.uLang('app.entity_removed', { entity: this.uLang('app.location') }),
                    icon: "success",
                    dangerMode: true,
                    button: this.uLang('app.continue')
                });
            }
        }
    }
</script>

<style lang="css" scoped>
</style>